export default "__VITE_ASSET__Cb$YUd6j__"